export default {"src":"/_next/static/media/ship-sticks-text-only.2543f045.svg","height":16,"width":67,"blurWidth":0,"blurHeight":0};